import config from '../../config/config';
import { sessionAwareFetch } from './sessionAwareFetch';

const apiBase = () => `${config.apimUrl}/business-lead-api`;

function headers(json = true) {
  const h = {
    'Ocp-Apim-Subscription-Key': config.apimKeyBusinessLeadService,
  };
  if (json) h['Content-Type'] = 'application/json';
  return h;
}

async function parseError(response) {
  let msg = `HTTP ${response.status}`;
  try {
    const j = await response.json();
    if (j?.error) msg = j.error;
  } catch {
    // ignore
  }
  return msg;
}

export const businessLeadService = {
  async listByBusiness(businessId) {
    const params = new URLSearchParams();
    params.set('businessId', businessId);
    const response = await sessionAwareFetch(`${apiBase()}?${params.toString()}`, {
      method: 'GET',
      headers: headers(false),
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error(await parseError(response));
    }
    return response.json();
  },

  async getById(leadId, businessId) {
    const params = new URLSearchParams();
    params.set('businessId', businessId);
    const response = await sessionAwareFetch(
      `${apiBase()}/${encodeURIComponent(leadId)}?${params.toString()}`,
      {
        method: 'GET',
        headers: headers(false),
        credentials: 'include',
      },
    );
    if (response.status === 404) {
      return null;
    }
    if (!response.ok) {
      throw new Error(await parseError(response));
    }
    return response.json();
  },

  async updateStatus(leadId, businessId, status) {
    const response = await sessionAwareFetch(
      `${apiBase()}/${encodeURIComponent(leadId)}/status`,
      {
        method: 'PATCH',
        headers: headers(),
        credentials: 'include',
        body: JSON.stringify({ businessId, status }),
      },
    );
    if (!response.ok) {
      const msg = await parseError(response);
      const err = new Error(msg);
      err.status = response.status;
      throw err;
    }
    return response.json();
  },

  /**
   * Admin: move a waitlist lead from empty-match onto a real business.
   * @param {string} leadId
   * @param {string} businessId
   */
  async assignToBusiness(leadId, businessId) {
    const response = await sessionAwareFetch(
      `${apiBase()}/${encodeURIComponent(leadId)}/assign`,
      {
        method: 'PATCH',
        headers: headers(),
        credentials: 'include',
        body: JSON.stringify({ businessId }),
      },
    );
    if (!response.ok) {
      const msg = await parseError(response);
      const err = new Error(msg);
      err.status = response.status;
      throw err;
    }
    return response.json();
  },
};
